/* Simply pass the isEuUser prop into the context */
export default _ref => {
  var shared = _ref.shared,
    isEuUser = _ref.isEuUser;
  shared.isEuUser = isEuUser; // eslint-disable-line no-param-reassign
  return {
    isEuUser
  };
};